export default "__VITE_ASSET__CIyLpkIZ__"